<template>
  <div class="ui-navigation"
       @mouseenter="showPerTooltip = true"
       @mouseleave="showPerTooltip = false">
    <transition name="fade">
      <ui-tooltip v-if="itemsPerPage"
                  v-show="showPerTooltip"
                  class="per-tooltip"
                  arrowCenter
                  arrowBottom>
        {{ $t('common.pagination.viewPerPage') }} : {{ itemsPerPage | thousand }}
      </ui-tooltip>
    </transition>
    <button class="prev"
            :disabled="currentPage === 1 || disabled"
            @click="setPage(currentPage - 1)">
      <i class="icon icon--arrow-left-small-black"></i>
    </button>
    <input type="text"
           v-model="page"
           :style="{ width: navigationWidth + 'px' }"
           :disabled="disabled"
           @keyup.enter="setCurrentPage"
           @blur="setCurrentPage">
    / {{ Math.max(lastPage, 1) | thousand }}
    <button class="next"
            :disabled="currentPage === lastPage || disabled"
            @click="setPage(currentPage + 1)">
      <i class="icon icon--arrow-right-small-black"></i>
    </button>
  </div>
</template>

<script>
import UiTooltip from '@/components/ui/UiTooltip'

export default {
  name: 'UiNavigation',
  components: {
    UiTooltip
  },
  props: ['currentPage', 'lastPage', 'itemsPerPage', 'disabled'],
  computed: {
    navigationWidth () {
      return Math.max(1, String(this.page).length) * 7.5 + 18.5
    }
  },
  watch: {
    currentPage (value) {
      this.page = value
    }
  },
  created () {
    this.page = 1
  },
  methods: {
    setCurrentPage () {
      this.setPage(this.page || 1)
    },
    setPage (page) {
      let currentPage = Math.max(Math.min(parseInt(page || 1) || 1, this.lastPage), 1)
      this.page = currentPage
      if (this.currentPage !== currentPage) {
        this.$emit('setPage', currentPage)
      }
    }
  },
  data () {
    return {
      page: 1,
      showPerTooltip: false
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-navigation {
  position: relative;
  font-size: 13px;
  color: #888;
  padding-top: 11px;

  .per-tooltip {
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);

    &.fade-enter-active,
    &.fade-leave-active {
      opacity: 1;
      bottom: 40px;
      transition: opacity 0.15s ease,
                  bottom 0.15s ease;
    }

    &.fade-enter,
    &.fade-leave-to {
      opacity: 0;
      bottom: 30px;
    }
  }

  .prev,
  .next {
    vertical-align: middle;
    width: 24px;
    height: 24px;
    padding: 3px;
    border: solid 1px #d7d7d7;
    background-color: #fff;
    border-radius: 20px;
    margin: -2px 8px 0;
    cursor: pointer;
    transition: background-color 0.2s ease;

    .icon {
      transition: opacity 0.2s ease;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.06);
    }

    &:disabled {
      pointer-events: none;
      cursor: default;

      .icon {
        opacity: 0.3;
      }
    }
  }

  input {
    vertical-align: middle;
    border-radius: 5px;
    border: solid 1px #bbb;
    background-color: #fff;
    font-size: 13px;
    font-weight: 500;
    color: #fc004e;
    text-align: center;
    height: 28px;
    line-height: 28px;
    margin-top: -2px;
    margin-right: 3px;
    transition: width 0.3s ease,
                border-color 0.2s ease,
                color 0.2s ease;

    &:hover {
      border-color: #888888;
    }

    &:focus {
      border-color: #289eef;
      color: #222222;
    }
  }
}
</style>
